const samplingExampleItemsTableColumns = [
  {
    key: 'images',
    label: 'Images',
    allowsSorting: false
  },
  {
    key: 'name',
    label: 'Name',
    allowsSorting: true
  },
  {
    key: 'example_item_type',
    label: 'Type',
    allowsSorting: true
  },
  {
    key: 'creator',
    label: 'Creator',
    allowsSorting: true
  },
  {
    key: 'stage',
    label: 'Stage',
    allowsSorting: true
  },
  {
    key: 'requested_at',
    label: 'Requested',
    allowsSorting: true
  }
];

export default samplingExampleItemsTableColumns;
